/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imageuploadinvalidtype3Inputs */

const en_imageuploadinvalidtype3 = /** @type {(inputs: Imageuploadinvalidtype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose a supported image file.`)
};

const de_imageuploadinvalidtype3 = /** @type {(inputs: Imageuploadinvalidtype3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähle eine unterstützte Bilddatei.`)
};

/**
* | output |
* | --- |
* | "Please choose a supported image file." |
*
* @param {Imageuploadinvalidtype3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imageuploadinvalidtype3 = /** @type {((inputs?: Imageuploadinvalidtype3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imageuploadinvalidtype3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imageuploadinvalidtype3(inputs)
	return de_imageuploadinvalidtype3(inputs)
});
export { imageuploadinvalidtype3 as "imageUploadInvalidType" }